<template>
	<div>
		<div class="payment-methods">
			
			<div class="payment-method" v-for="(method, i) in availableMethods" :key="i" @click="selectMethod(method)" :class="{ selected: selected == method }">
				<div class="selected"><i class="icon icon-check-bold invert"></i></div>
				<img :src="method.image" class="img-fluid" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PaymentMethods',
	data() {
		return {
			ENV: process.env.VUE_APP_ENV,
			selected: null,
			paymentMethods: [
				{
					name: 'OCA',
					code: 4,
					type: 'CARD',
					image: require('@/assets/img/icon-payment-oca.png'),
					env: 'production'
				},
				{
					name: 'VISA',
					code: 1,
					type: 'CARD',
					image: require('@/assets/img/icon-payment-visa.png'),
					env: 'production'
				},
				{
					name: 'MASTER',
					code: 2,
					type: 'CARD',
					image: require('@/assets/img/icon-payment-master.png'),
					env: 'production'
				},
				{
					name: 'BROU',
					code: 5,
					type: 'BANK',
					image: require('@/assets/img/icon-payment-brou.png'),
					env: 'development'
				},
				{
					name: 'BBVA',
					code: 12,
					type: 'BANK',
					image: require('@/assets/img/icon-payment-bbva.png'),
					env: 'development'
				},
				{
					name: 'BANDES',
					code: 27,
					type: 'BANK',
					image: require('@/assets/img/icon-payment-bandes.png'),
					env: 'development'
				},
				{
					name: 'SCOTIABANK',
					code: 29,
					type: 'BANK',
					image: require('@/assets/img/icon-payment-scotia.png'),
					env: 'development'
				},
				{
					name: 'REDPAGOS',
					code: 10,
					type: 'OFFLINE',
					image: require('@/assets/img/icon-payment-redpagos.png'),
					env: 'production'
				},
				{
					name: 'ABITAB',
					code: 5,
					type: 'OFFLINE',
					image: require('@/assets/img/icon-payment-abitab.png'),
					env: 'production'
				},
			],
		}
	},
	computed:{
		// filter selectedMethods by env
		availableMethods() {
			console.log(this.ENV)
			if( this.ENV == 'production'){
				return this.paymentMethods.filter(method => method.env == this.ENV)
			}else{
				return this.paymentMethods
			}
		},
	},
	methods: {
		selectMethod(method) {
			this.selected = method
			this.$emit('selected', method)
		},
	},
}
</script>

<style scoped>
.payment-methods {
	margin: 12px 0px;
	display: flex;
	gap: 4px;
	cursor: pointer;
	flex-wrap: wrap;
	width: 100%;
	justify-content: center;
}

.payment-methods .payment-method {
	border: solid 1px #cecece;
	width: 116px;
	height: 64px;
	flex-grow: 0;
	flex-shrink: 0;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
}
.payment-methods .payment-method:hover {
	background-color: #f3f3f3;
}

.payment-methods .payment-method .selected {
	width: 14px;
	height: 14px;
	background-color: #157eea;
	position: absolute;
	border-radius: 8px;
	top: 6px;
	right: 6px;
	display: none;
}
.payment-methods .payment-method .selected .icon {
	width: 14px;
	height: 14px;
}
.payment-methods .payment-method.selected {
	border-color: #157eea;
}
.payment-methods .payment-method.selected .selected {
	display: block;
}
</style>
